import React from 'react';
import classNames from 'classnames';
import InputMask from 'react-input-mask';

const FormInput = ({
	id,
	title,
	type,
	name,
	placeholder,
	maxLength,
	required,
	textarea,
	onChange,
	editCssMod,
	showLabelCssMod,
	dateType,
	value
}) => {

	const inputClasses = classNames('form_field default_mod', { edit_mod: editCssMod });
	const fieldWrapClasses = classNames('form_cell_title form_v1_mod', { hline_hide_mod: !showLabelCssMod });

	return (
		<dl className="form_cell form_cell_v1_mod">
			<dt className={fieldWrapClasses}>
				<label htmlFor={id}>{title}</label>
			</dt>
			<dd className="form_field_wrap form_v1_mod">
				{textarea ? (
					<textarea
						className="form_field textarea_mod_1 edit_mod textarea_size_mod"
						id={id}
						type={type}
						name={name}
						placeholder={placeholder}
						required={required}
						onChange={onChange ? onChange : null}
					/>
				) : (
						<React.Fragment>
							{dateType ? (
								<InputMask
									className={inputClasses}
									id={id}
									type={type}
									name={name}
									placeholder={placeholder}
									required={required}
									onChange={onChange ? onChange : null}
									mask="99/99/9999"
								></InputMask>
							) : (
									<input
										className={inputClasses}
										id={id}
										type={type}
										name={name}
										placeholder={placeholder}
										required={required}
										onChange={onChange ? onChange : null}
										maxLength={maxLength}
									/>
								)}
						</React.Fragment>
					)}
			</dd>
		</dl>
	);
}

export default FormInput;